"use strict";
/*
 *@description:notice跑马灯-可支持多条
 *@author: qiuhongyang
 *@date: 2022-05-31 09:03:24
*/
Object.defineProperty(exports, "__esModule", { value: true });
require('./animation_polifill');
require("./style.less");
var stopanimate = false;
var HorseLamp = /** @class */ (function () {
    function HorseLamp(opt) {
        this.animationId = 0;
        this.run = true;
        this.timer = null;
        this.start = 0;
        this.innerWidth = 0;
        this.boxWidth = 650;
        this.configinfo = {
            bg_color: "#FFF",
            color: "#000",
            font_size: 12,
            speed: 1,
            text: "",
            interval: 0 // 停留时间
        };
        this.intervaltop = false;
        this.container = opt.container;
        this.configinfo = opt.configinfo;
        this.initHorseLamp();
        // this.bindEvent();
    }
    ;
    HorseLamp.prototype.getFontsize = function () {
        return this.configinfo.font_size ? this.configinfo.font_size + 11 : 12;
    };
    HorseLamp.prototype.getInnerDom = function () {
        var config = this.configinfo;
        var str = "<div class=\"notice-container\" id=\"noticeBox\" style=\"background:".concat(config.bg_color, ";opacity:.85;\">\n            <div class=\"notice-inner\" id=\"noticeInner\">\n                <p style=\"font-size:").concat(this.getFontsize(), "px;color:").concat(config.color, ";\">").concat(config.text, "</p>\n            </div>\n        </div>");
        return $(str);
    };
    HorseLamp.prototype.initHorseLamp = function () {
        var that = this;
        // if (that.container.children("#noticeBox").length > 0) return false;
        var inner = this.getInnerDom();
        this.container.empty().append(inner);
        setTimeout(function () {
            var noticebox = document.getElementById("noticeBox");
            that.boxWidth = noticebox.offsetWidth;
            that.start = that.boxWidth;
            that.noticeInner = document.getElementById("noticeInner");
            that.childNodes = that.noticeInner.childNodes;
            var count = 0;
            that.childNodes.forEach(function (item) {
                if (item.nodeType === 1) {
                    that.innerWidth += parseInt(self.getComputedStyle(item).width.split('px')[0]);
                    count++;
                }
            });
            that.innerWidth += that.boxWidth * (count - 1);
            // if (that.innerWidth > that.boxWidth) {
            that.animations();
            // }
        }, 500);
    };
    HorseLamp.prototype.getSpeed = function () {
        var speed = this.configinfo.speed > 5 ? 5 : this.configinfo.speed;
        return speed ? 120 - speed * 20 : 50;
    };
    HorseLamp.prototype.getIntervel = function () {
        var that = this;
        var num = this.configinfo.interval || 1;
        if (that.intervaltop)
            return;
        that.intervaltop = true;
        var _loop_1 = function (i) {
            setTimeout(function () {
                if (i == num) {
                    that.run = true;
                    that.intervaltop = false;
                }
            }, 1000 * i);
        };
        for (var i = 0; i <= num; i++) {
            _loop_1(i);
        }
        return 0;
    };
    ;
    HorseLamp.prototype.animations = function () {
        var that = this;
        _animation();
        return this;
        function _animation() {
            if (!that.run) {
                that.getIntervel();
                return false;
            }
            // if (!that.run) return;
            clearInterval(that.timer);
            that.animationId = null;
            that.start -= 1;
            that.noticeInner.style.cssText = "transform: translate3d(".concat(that.start, "px, 0, 0)");
            if (that.innerWidth < -that.start) {
                that.run = false;
                that.start = that.boxWidth;
                that.noticeInner.style.cssText = "transform: translate3d(".concat(that.start, "px, 0, 0)");
            }
            ;
            // that.animationId = requestAnimationFrame(_animation)
            that.timer = setInterval(function () {
                _animation();
            }, that.getSpeed());
        }
    };
    HorseLamp.prototype.bindEvent = function () {
        var that = this;
        this.noticeInner.onmouseover = function () {
            that.run = false;
            cancelAnimationFrame(this.animateId);
        };
        this.noticeInner.onmouseout = function () {
            that.run = true;
            clearTimeout(that.timer);
            that.timer = setTimeout(function () {
                cancelAnimationFrame(that.animationId);
                that.animations();
            }, 200);
        };
    };
    return HorseLamp;
}());
exports.default = HorseLamp;
//# sourceMappingURL=data:application/json;base64,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